import { environment } from "../environments/environment";

export const localStorageName = {
  diagnoza: `${environment.projectName}_diagnoza`,
  diagnozaOdp: `${environment.projectName}_diagnoza_odp`,
  token: `${environment.projectName}_token`,
  cookies: `${environment.projectName}_cookies`,
}
